import React from 'react';
import './LoadingSpinner.css'; // Odkaz na CSS zůstává
// Use PUBLIC_URL to reference images from public folder in CRA
const quoteMachineLogo = process.env.PUBLIC_URL + '/images/QuoteMachine.png'; // Cesta k logu

const LoadingSpinner = ({ text = "Loading..." }) => {
    return (
        <div className="spinner-overlay">
            <div className="spinner-box">
                <div className="spinner-logo-container">
                    <img src={quoteMachineLogo} alt="QuoteMachine Logo" className="spinner-logo" />
                </div>
                <p className="spinner-text">{text}</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;